import { render } from "./inventory-status-report.vue?vue&type=template&id=60128ae0&scoped=true"
import script from "./inventory-status-report.vue?vue&type=script&lang=js"
export * from "./inventory-status-report.vue?vue&type=script&lang=js"

import "./inventory-status-report.vue?vue&type=style&index=0&id=60128ae0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60128ae0"]])

export default __exports__